import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserContextService } from '../../../core/context/user.context';
import { AvatarComponent } from '../avatar/avatar.component';
import { NotificationModalComponent } from './notification-modal/notification-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from '../../../services/authentication.service';
import { WebServiceWorker } from '../../../services/web-service-worker.service';
import { SwUpdate } from '@angular/service-worker';
import { WebSocketNotificationService } from '../../../services/websocket-notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, AvatarComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  user: any | null = null;
  isNewAppVersionAvailable: boolean = false;
  newAppUpdateAvailableSubscription: any;
  versionHash: string | null = null;
  unreadCount: number = 0;

  private unreadSub: Subscription | null = null;

  constructor(
    private readonly _userContext: UserContextService,
    private authenticationService: AuthenticationService,
    private webServiceWorker: WebServiceWorker,
    private swUpdate: SwUpdate,
    private dialog: MatDialog,
    private wsNotification: WebSocketNotificationService
  ) {}

  ngOnInit() {
    this.user = localStorage.getItem('currentUser');
    this.user = this.user ? JSON.parse(this.user) : null;
    this.checkIfAppUpdated();

    if (this.swUpdate.isEnabled) {
      console.log('Service worker running.');
      this.swUpdate.versionUpdates.subscribe((event: any) => {
        console.log(event);
        this.versionHash = event?.version?.hash;
      });
    }

    // Conectar WebSocket usando el userId y rol del usuario autenticado
    const userId = this.user?.usuId ?? this.user?.id ?? 'guest';
    const rawRole = this.user?.perfil?.nombre ?? this.user?.perfil?.rolNombre ?? this.user?.role ?? this.user?.rol ?? undefined;
    const role = rawRole ? WebSocketNotificationService.normalizeRole(String(rawRole)) : undefined;
    this.wsNotification.connect(String(userId), role);

    this.unreadSub = this.wsNotification.unreadCount$.subscribe(count => {
      this.unreadCount = count;
    });
  }

  toggleModal() {
    this.dialog.open(NotificationModalComponent, {
      width: '600px',
      height: '600px',
      panelClass: 'dialog-generico'
    });
  }

  logout() {
    this.authenticationService.logout();
  }

  checkIfAppUpdated() {
    this.newAppUpdateAvailableSubscription =
      this.webServiceWorker.$isAnyNewUpdateAvailable.subscribe(
        (versionAvailableFlag: boolean) => {
          this.isNewAppVersionAvailable = versionAvailableFlag;
        }
      );
  }

  ngOnDestroy() {
    this.newAppUpdateAvailableSubscription?.unsubscribe();
    this.unreadSub?.unsubscribe();
    this.wsNotification.disconnect();
  }

  refreshApp() {
    window.location.reload();
  }
}
